import { Suspense } from 'react';
import { css, useTheme } from '@emotion/react';
import { ChatRoomList } from '~/components/Chat';
import { ChatListErrorBoundary } from '~/components/ErrorBoundary';
import { HelmetHead } from '~/components/common';
import { ChatRoomListSkeleton } from '~/components/common/Skeleton';

export default function ChatList() {
  const theme = useTheme();

  return (
    <>
      <HelmetHead title={'Chat'} />

      <div
        css={css`
          width: 100%;
          min-height: 100%;
          padding: ${theme.layout.chat_header_height} 0
            ${theme.layout.chat_navigation_height};
        `}
      >
        <ChatListErrorBoundary>
          <Suspense fallback={<ChatRoomListSkeleton />}>
            <ChatRoomList />
          </Suspense>
        </ChatListErrorBoundary>
      </div>
    </>
  );
}
